import { render, staticRenderFns } from "./WaiverFormCommon.vue?vue&type=template&id=22ba8801&scoped=true&"
import script from "./WaiverFormCommon.vue?vue&type=script&lang=js&"
export * from "./WaiverFormCommon.vue?vue&type=script&lang=js&"
import style0 from "./WaiverFormCommon.vue?vue&type=style&index=0&id=22ba8801&lang=scss&scoped=true&"
import style1 from "./WaiverFormCommon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba8801",
  null
  
)

export default component.exports